import React, { useState, useEffect } from "react";
import { Container, DropdownButton, Dropdown, FormControl } from "react-bootstrap";
import { descargarArchivo } from "../AccionesBackend";

const PdfItem = ({ pdf }) => {
    const isImage = pdf.src.match(/\.(jpeg|jpg|gif|png|webp)$/i);

    return (
        <div className="report-item" style={{ cursor: "pointer" }}>
            <a href={pdf.src} target="_blank" rel="noopener noreferrer">
                {isImage ? (
                    <img
                        src={pdf.src}
                        alt={pdf.title}
                        width="400"
                        height="200"
                        style={{ objectFit: "cover" }}
                    />
                ) : (
                    <object
                        data={`${pdf.src}#page=1`}
                        type="application/pdf"
                        width="400"
                        height="200"
                    >
                        <p>No se pudo cargar la miniatura. <br />Haz clic para ver el PDF.</p>
                    </object>
                )}
            </a>
            <h3 className="text-break">{pdf.title}</h3>
            <div className="button-group">
                <button
                    onClick={() => descargarArchivo(pdf.seccionId, pdf.title)}
                    className="btn btn-success me-2"
                >
                    <i className="bi bi-download me-1"></i>
                    Descargar
                </button>
                <button
                    onClick={() => window.open(pdf.src, "_blank", "noopener,noreferrer")}
                    className="btn btn-primary"
                >
                    <i className="bi bi-arrows-fullscreen me-1"></i>
                    Vista Completa
                </button>
            </div>
        </div>
    );
};


// Dropdown que incluye la barra de búsqueda para filtrar tanto los items del dropdown
// como la lista principal de PDFs.
const PdfDropdown = ({ pdfs, selectedPdf, setSelectedPdf, searchTerm, setSearchTerm }) => {
    // Filtrar los PDFs usando el mismo searchTerm que se usará para la lista principal
    const filteredPdfs = pdfs.filter((pdf) =>
        pdf.title.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <DropdownButton
            title={selectedPdf ? selectedPdf.title : "Selecciona un archivo"}
            variant="secondary"
            className="mb-3"
        >
            {/* Barra de búsqueda interna en el dropdown */}
            <div className="px-3 pb-2">
                <FormControl
                    type="text"
                    placeholder="Buscar archivo..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
            </div>

            {filteredPdfs.length > 0 ? (
                filteredPdfs.map((pdf) => (
                    <Dropdown.Item
                        key={pdf.src} // Se asume que 'pdf.src' es único
                        onClick={() => {
                            setSelectedPdf(pdf);
                            window.open(pdf.src, "_blank", "noopener,noreferrer");
                        }}
                        active={selectedPdf && pdf.src === selectedPdf.src}
                    >
                        {pdf.title}
                    </Dropdown.Item>
                ))
            ) : (
                <Dropdown.ItemText className="text-center text-muted">
                    No se encontraron resultados
                </Dropdown.ItemText>
            )}
        </DropdownButton>
    );
};

export const VisualizadorPdfs = ({ initialPdfs }) => {
    const [pdfs, setPdfs] = useState(initialPdfs || []);
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedPdf, setSelectedPdf] = useState(null);

    // Actualizar el estado 'pdfs' cuando 'initialPdfs' cambie
    useEffect(() => {
        setPdfs(initialPdfs || []);
    }, [initialPdfs]);

    // Filtrar PDFs según el término de búsqueda global (compartido con el dropdown)
    const filteredPdfs = pdfs.filter((pdf) =>
        pdf.title.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <section className="reportes">
            <Container>
                <div className="content">
                    <div className="filter-section">
                        {/* Único dropdown con barra de búsqueda */}
                        <PdfDropdown
                            pdfs={pdfs}
                            selectedPdf={selectedPdf}
                            setSelectedPdf={setSelectedPdf}
                            searchTerm={searchTerm}
                            setSearchTerm={setSearchTerm}
                        />
                    </div>
                    <div className="report-list">
                        {filteredPdfs.map((pdf, index) => (
                            <PdfItem key={index} pdf={pdf} />
                        ))}
                    </div>
                </div>
            </Container>
        </section>
    );
};
